{
  "srTitle": "反猎杀平民项目——为乌克兰赫尔松的平民提供无人机防护",
  "logoAlt": "反猎杀平民项目标识",
  "intro": "我们为乌克兰赫尔松的志愿者、应急服务人员和关键基础设施工作者提供防护装备，以抵御小型无人机的袭击。",
  "safari": "自2024年夏天以来，赫尔松的平民持续遭到俄罗斯军队使用视频无人机的系统性猎杀，这场恐怖行动被称为“猎杀平民”（Human Safari）。",
  "unLink": "联合国委员会认定“猎杀平民”为战争罪",
  "donateNow": "立即捐助",
  "donateMonthly": "每月捐款",
  "otherWays": "其他捐助方式",
  "instagram": "Instagram",
  "pastFundraisers": "往期筹款：",
  "fundraiser2025": "2025年筹款",
  "donateVia": "捐助方式：",
  "charityRef": "通过英国慈善机构，备注：",
  "germanCharityRef": "通过德国慈善机构，备注：",
  "copy": "复制",
  "copied": "已复制！",
  "close": "关闭",
  "viewMedia": "查看媒体",
  "andrushenkoCredit": "奥列克桑德尔·安德留先科，Vgoru 媒体摄影记者",
  "fruitSellerDescription": "水果小贩遭光纤无人机追击",
  "khersonPoliceCredit": "来自 @khersonpolice",
  "firefighterDescription": "消防员在“猎杀平民”袭击后扑灭起火车辆，后方躺着一名受害者",
  "previousMedia": "上一个",
  "nextMedia": "下一个",
  "fpvDroneDescription": "“猎杀平民”行动中出动的 FPV 无人机",
  "busAttackDescription": "针对公共交通的众多 FPV 无人机袭击之一",
  "notFoundTitle": "页面未找到",
  "notFoundMessage": "该页面不存在，可能已被移动，或者链接有误。",
  "backHome": "返回首页",
  "droneDetectorDescription": "无人机探测器是小型手持设备，可在无人机靠近时发出警报",
  "vestDescription": "轻便的防护背心可以减轻无人机袭击造成的伤害"
}
